module.exports = __webpack_public_path__ + "static/media/rooms-ch3.06a2e3f5.png";